import { getNotificationsFromDirectus } from "directus/src/operations";

export const NOTIFICATION_COLLECTION = {
    notifications: {
        api: getNotificationsFromDirectus,
    },
}

export const LIST_VERSION = 4;